import { useMutateItemWithUpload } from '../../../hooks/entityMethodsHook'

export const useMutateMatchWorkerFace = (key: string) => {
  const uri = `users/match-worker-face`
  return useMutateItemWithUpload(key, uri)
}
